<template>
	<div>
		<div class="pc_top">
		  
		  <!--head-->
		  <div class="head"><a href="javascript:void(0)" class="en">EN</a>
		    <div class="logo"><a href="01 index.html"><img src="@/assets/images/logo.png" /></a></div>
		    
		    <!--menu-->
		    
		    <ul id="nav">
		      <li class="mainlevel" ><a href="javascript:void(0)" @click="go('/')" :class="sel==1?'cur':''">首页</a> </li>
		      <li class="mainlevel"><a href="javascript:void(0)" @click="go('/about')" :class="sel==2?'cur':''">关于我们</a>
		        <ul>
		          <li><a href="javascript:void(0)" @click="go('/about?id=1665618104755376128')">公司简介</a></li>
		          <li><a href="javascript:void(0)" @click="go('/about?id=1665618176524111872')">企业文化</a></li>
		          <li><a href="javascript:void(0)" @click="go('/about?id=1665618228105662464')">荣誉资质</a></li>
		        </ul>
		      </li>
		      <li class="mainlevel"><a href="javascript:void(0)" :class="sel==3?'cur':''" @click="go('/newList?type=1001')">新闻中心</a>
		        <ul>
		          <li><a href="javascript:void(0)" @click="go('/newList?type=1001')">公司新闻</a></li>
		          <li><a href="javascript:void(0)" @click="go('/newList?type=1002')">行业新闻</a></li>
		        </ul>
		      </li>
		      <li class="mainlevel"><a href="javascript:void(0)" :class="sel==4?'cur':''" @click="go('/productList')">产品中心</a></li>
		      <li class="mainlevel"><a href="http://haihang.jd.com"  target="_blank">在线商城</a></li>
		      <li class="mainlevel"><a href="javascript:void(0)" :class="sel==6?'cur':''" @click="go('/contact')">联系我们</a></li>
		      <div class="clear"> </div>
		    </ul>
		    
		    <!--menu-->
		    
		    <div class="clear"></div>
		  </div>
		  <!--head--> 
		  
		</div>
		<!--shoujitop-->
		<div class="shouji_top">
		  <header :class="['cd-main-header',showPhone?'nav-is-visible':'']"> <a class="cd-logo" href="javascript:void(0)"><img src="@/assets/images/logo.png"  width="180" alt="Logo"></a>
		    <ul class="cd-header-buttons">
		      <li><a :class="['cd-nav-trigger',showPhone?'nav-is-visible':'']" @click="changePhone"><span></span></a></li>
		    </ul>
		    <!-- cd-header-buttons --> 
		  </header>
		  <nav class="cd-nav">
		    <ul id="cd-primary-nav" :class="['cd-primary-nav is-fixed',showPhone?'nav-is-visible':'']">
		      <li><a href="javascript:void(0)" @click="go('/')">首页</a></li>
		      <li class="has-children"> <a href="javascript:void(0)"  @click="go('/about')">关于我们</a>
		        <ul class="cd-secondary-nav is-hidden">
		          <li class="go-back"><a href="javascript:void(0)">返回</a></li>
		          <li class="see-all"><a href="javascript:void(0)" @click="go('/about?id=1665618104755376128')">公司简介</a></li>
		          <li class="see-all"><a href="javascript:void(0)" @click="go('/about?id=1665618176524111872')">企业文化</a></li>
		          <li class="see-all"><a href="javascript:void(0)" @click="go('/about?id=1665618228105662464')">荣誉资质</a></li>
		        </ul>
		      </li>
		      <li class="has-children"> <a href="javascript:void(0)"  @click="go('/newList?type=1001')">新闻中心</a>
		        <ul class="cd-secondary-nav is-hidden">
		          <li class="go-back"><a href="javascript:void(0)">返回</a></li>
		          <li class="see-all"><a href="javascript:void(0)"  @click="go('/newList?type=1001')">公司新闻</a></li>
		          <li class="see-all"><a href="javascript:void(0)"  @click="go('/newList?type=1002')">行业新闻</a></li>
		        </ul>
		      </li>
		      <li> <a href="javascript:void(0)" @click="go('/productList')">产品中心</a></li>
		      <li> <a href="https://jichangbj.1688.com/" target="_blank">在线商城</a></li>
		      <li> <a href="javascript:void(0)"  @click="go('/contact')">联系我们</a></li>
		    </ul>
		    <!-- primary-nav --> 
		  </nav>
		  <!-- cd-nav --> 
		  
		</div>
		<!--shoujitop-->
	</div>
</template>

<script>
	export default {
		components: {},
		props: {
			
			sel:{
				type: Number,
				default:1
			}
		 
		},
		data() {
			return {
				showPhone:false,
				token:''
			}
		},
		computed: {

		},
		mounted() {
			//this.token=window.sessionStorage.getItem('token')
		},
		methods: {
			changePhone(){
				this.showPhone=!this.showPhone
				this.$emit('changePhone',this.showPhone)
			},
			changeTag(item){
				this.selTag=item
			},
			
			go(url){
				if(this.$route.fullPath!=url){
					this.$router.push(url)
					this.$router.go(0)
				}
			}
		}
	}
</script>

